// extracted by mini-css-extract-plugin
export default {"contentPage":"ScrollGoods_contentPage__LRg3A","contentPageByPanel":"ScrollGoods_contentPageByPanel__ZgQ6s","bottomPanelSpacer":"ScrollGoods_bottomPanelSpacer__LnIC0"};